import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Layers } from "lucide-react";
import { SectionTitle } from "@/components/Shared";
import { ISSUE_ICONS } from "@/lib/issues";

// One tile per distinct Under-the-Lens category; issues and PILs within a category are aggregated.
export default function DomainsSection({ issues }) {
  const groups = Object.values(issues.reduce((acc, i) => {
    const g = acc[i.category] || (acc[i.category] = { name: i.category, icon: i.icon, issues: 0, pils: 0 });
    g.issues += 1;
    g.pils += i.counts?.pil || 0;
    return acc;
  }, {})).sort((a, b) => b.issues - a.issues || a.name.localeCompare(b.name));
  if (!groups.length) return null;
  return (
    <section className="bg-npst-bgAlt border-y border-npst-line" data-testid="domains-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <SectionTitle eyebrow="Areas of Work" title="Principal Domains of Public Interest" className="mb-12" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-npst-line rounded-md overflow-hidden">
          {groups.map((g, i) => {
            const Icon = ISSUE_ICONS[g.icon] || Layers;
            return (
              <Link key={g.name} to={`/issues?category=${encodeURIComponent(g.name)}`} data-testid={`area-${g.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group bg-npst-bg p-7 border-r border-b border-npst-line transition-colors hover:bg-white">
                <div className="flex items-center justify-between mb-3">
                  <span className="font-mono text-xs text-npst-gold">{String(i + 1).padStart(2, "0")}</span>
                  <Icon size={18} strokeWidth={1.6} className="text-npst-gold/70 transition-colors group-hover:text-npst-navy" />
                </div>
                <div className="font-serif text-xl text-npst-ink leading-snug group-hover:text-npst-navy">{g.name}</div>
                <div className="mt-3 flex items-center justify-between text-[11px] uppercase tracking-[0.12em] text-npst-muted font-semibold">
                  <span data-testid="area-counts">{g.issues} {g.issues === 1 ? "issue" : "issues"}{g.pils ? ` · ${g.pils} ${g.pils === 1 ? "PIL" : "PILs"}` : ""}</span>
                  <ArrowUpRight size={14} className="text-npst-gold opacity-0 transition-opacity group-hover:opacity-100" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
